import React from 'react';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import Select from '../../../../../components/input/Select';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import { addAllItemToSelectList, setColumnWidth } from '../../../../../lib/common';
import Anchor from '../../../../../components/link/Anchor';

/**
 *  선택된 브랜드 아이템 리스트와 브랜드 리스트의 공통 컬럼
 */
export const columns = (data) => {
  const {
    list,
    filterOption,
    onFilter,
    openImgViewModal,
    mainProductCategorySelectList = [],
    subProductCategorySelectList = { null: [] },
    getProductSubCategoryList,
  } = data;
  const targetParentId = filterOption && filterOption.mainCategory ? filterOption.mainCategory : null;

  return [
    {
      id: 'url',
      Header: '이미지',
      accessor: 'url',
      fixed: 'left',
      width: 100,
      Cell: (row) => <TableColumnImg url={row.value} openImgViewModal={openImgViewModal} />,
    },
    {
      accessor: 'brandName',
      Header: '브랜드명',
      filterable: !!filterOption,
      fixed: 'left',
      minWidth: 160,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.brandName} onFilter={(brandName) => onFilter({ brandName })} />
      ),
    },
    {
      accessor: 'storeId',
      Header: '브랜드 ID',
      filterable: !!filterOption,
      fixed: 'left',
      width: 70,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      accessor: 'productId',
      Header: '상품 ID',
      filterable: !!filterOption,
      fixed: 'left',
      minWidth: 80,
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productId} onFilter={(productId) => onFilter({ productId })} />
      ),
    },
    {
      accessor: 'mainCategory',
      Header: '1차 카테고리',
      filterable: !!filterOption,
      fixed: 'left',
      width: setColumnWidth(list, 'mainCategory') + 40,
      Filter: () => (
        <Select
          list={addAllItemToSelectList(mainProductCategorySelectList)}
          onChange={(mainCategory) =>
            onFilter({
              mainCategory,
              subCategory: null,
            })
          }
          defaultValue={filterOption.mainCategory}
          value={filterOption.mainCategory}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'isSubCategoryExists',
      Header: '2차 카테고리',
      filterable: !!filterOption,
      fixed: 'left',
      width: 120,
      Cell: (row) =>
        row.value ? (
          <Anchor
            text="카테고리 보기"
            isUnderLine
            color="primary"
            onClick={() =>
              getProductSubCategoryList({
                productId: row.original.productId,
              })
            }
          />
        ) : (
          '-'
        ),
      Filter: () => (
        <Select
          list={addAllItemToSelectList(subProductCategorySelectList[targetParentId])}
          onChange={(subCategory) => onFilter({ subCategory })}
          defaultValue={filterOption.subCategory}
          value={filterOption.subCategory}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'productName',
      Header: '상품명',
      className: 'align-left',
      resizable: true,
      filterable: !!filterOption,
      minWidth: 200,
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productName} onFilter={(productName) => onFilter({ productName })} />
      ),
    },
    {
      accessor: 'originPrice',
      Header: '판매가',
      minWidth: 80,
    },
    {
      accessor: 'discountPrice',
      Header: '할인가',
      minWidth: 120,
    },
    {
      accessor: 'discountPeriod',
      Header: '할인기간',
      minWidth: 320,
    },
    {
      accessor: 'salesPrice',
      Header: '실판매가',
      minWidth: 120,
    },
    {
      accessor: 'createDate',
      Header: '등록일',
      minWidth: 120,
    },
  ];
};
